import { render, staticRenderFns } from "./EmployeesPanel.vue?vue&type=template&id=825f31aa&scoped=true&"
import script from "./EmployeesPanel.vue?vue&type=script&lang=ts&"
export * from "./EmployeesPanel.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeesPanel.vue?vue&type=style&index=0&id=825f31aa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825f31aa",
  null
  
)

export default component.exports